import { TeamSettingsService } from '../../../core/services/team-settings.service';
import useService from '../../../injector/hooks/useService';

export default function useTeamSettings() {
  const teamSettingsService = useService(TeamSettingsService);

  return {
    getTeamSettingsValue: () => teamSettingsService.getTeamSettingsValue(),
    getTeamSettings: () => teamSettingsService.getTeamSettingsValue(),
    isRBACEnabled: teamSettingsService.isRBACEnabled(),
    isFBAdsSearchEnabled: teamSettingsService.isFBAdsSearchEnabled(),
    isWebhookEventsEnabled: teamSettingsService.isWebhookEventsEnabled(),
    isWorkFlowsEnabled: teamSettingsService.isWorkflowsEnabled(),
    isMongoDbDisplayParseAsStringOptionEnabled: teamSettingsService.isMongoDbDisplayParseAsStringOptionEnabled(),
    isDraftPipelineEnabled: teamSettingsService.isDraftPipelineEnabled(),
    getVPCPeeringConfig: () => teamSettingsService.getVPCPeeringConfig(),
    isHistoricalTaskSeparationForTableModeEnabled: teamSettingsService.isHistoricalTaskSeparationForTableModeEnabled(),
    isServerlessAllowedForTeam: () => teamSettingsService.isServerlessAllowedForTeam(),
    isH2OEnabled: () => teamSettingsService.isH2OEnabled(),
    isH20BillingEnabled: () => teamSettingsService.isH20BillingEnabled(),
    get isEdgeAsDefaultEnabled() {
      return teamSettingsService.isEdgeAsDefaultEnabled();
    },
    isYukiProxyForSnowflakeEnabled: teamSettingsService.isYukiProxyForSnowflakeEnabled(),
    showPubKeyMessageTeam: teamSettingsService.showPubKeyMessageTeam()
  };
}
